<ng-container *ngIf="'desktop' | mediaQuery">
    <tt-card class="col-xs-4 p-5" ttHeading="h_address">
        <ng-container *ngTemplateOutlet="address"></ng-container>
    </tt-card>

    <tt-card class="col-xs-4 p-5" ttHeading="h_other">
        <ng-container *ngTemplateOutlet="other"></ng-container>
    </tt-card>

    <tt-card class="col-xs-4 p-5" ttHeading="h_terms">
        <ng-container *ngTemplateOutlet="terms"></ng-container>
    </tt-card>
</ng-container>

<ng-container *ngIf="['tablet', 'laptop'] | mediaQuery">
    <div class="col-xs-6 sp-0">
        <tt-card class="col-xs-12 p-5" ttHeading="h_address">
            <ng-container *ngTemplateOutlet="address"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 p-5" ttHeading="h_other">
            <ng-container *ngTemplateOutlet="other"></ng-container>
        </tt-card>
    </div>

    <tt-card class="col-xs-6 p-5" ttHeading="h_terms">
        <ng-container *ngTemplateOutlet="terms"></ng-container>
    </tt-card>
</ng-container>

<ng-container *ngIf="'mobile' | mediaQuery">
    <tt-tabs #tabs>
        <tt-tab ttId="ADDRESS" ttLabel="bg_customeredit_main_address"></tt-tab>
        <tt-tab ttId="TERMS" ttLabel="bg_customeredit_main_terms"></tt-tab>
        <tt-tab ttId="OTHER" ttLabel="bg_customeredit_main_other"></tt-tab>
    </tt-tabs>
    <tt-card [hidden]="tabs.ttSelectedId !== 'ADDRESS'">
        <ng-container *ngTemplateOutlet="address"></ng-container>
    </tt-card>

    <tt-card [hidden]="tabs.ttSelectedId !== 'OTHER'">
        <ng-container *ngTemplateOutlet="other"></ng-container>
    </tt-card>

    <tt-card [hidden]="tabs.ttSelectedId !== 'TERMS'">
        <ng-container *ngTemplateOutlet="terms"></ng-container>
    </tt-card>
</ng-container>

<tt-card class="col-xs-12 sp-0" [ngClass]="{ 'tt-customer-edit__sticky-bottom': !('mobile' | mediaQuery) }">
    <tt-button-save (ttClick)="manualSave()" [ttLoading]="saving"></tt-button-save>
    <tt-button-settings *ngIf="get?.show_setting === '1'" ttWebpageName="customeredit"></tt-button-settings>
</tt-card>

<ng-template #address>
    <ng-container *ngIf="!!get && !!params">
        <tt-search
            *ngIf="params.cust_no === '0' && get.setting_customeredit_show_brreg_find_customer === '1'"
            ttLabel="customeredit_brreg_find_customer"
            [(ttModel)]="get.brreg_find_customer"
            [ttSearch]="brRegSearch"
            ttDataId="organisasjonsnummer"
            ttDataName="resultnavn"
            (ttOnSelected)="onBrRegSelected($event)"
        ></tt-search>
        <tt-input *ngIf="!(params.cust_no === '0' && get.set_cust_no === '1')" ttLabel="cust_no" [ttModel]="get.cust_no" ttReadonly></tt-input>
        <tt-input-number
            *ngIf="params.cust_no === '0' && get.set_cust_no === '1'"
            [ttInvalid]="invalid.cust_no?.invalid ?? false"
            [ttInvalidText]="invalid.cust_no?.message ?? ''"
            ttLabel="cust_no"
            [(ttModel)]="get.cust_no"
            (ttModelChange)="onCustNoChanged($event)"
            ttDecimals="0"
            ttAlwaysPositive
        ></tt-input-number>
        <tt-input
            [ttInvalid]="invalid.cust_name?.invalid ?? false"
            [ttInvalidText]="invalid.cust_name?.message ?? ''"
            ttRequired
            ttLabel="cust_name"
            [(ttModel)]="get.cust_name"
            (ttModelChange)="get.cust_name_sort = $event; onCommonChange()"
        ></tt-input>
        <tt-checkbox
            *ngIf="get.setting_customeredit_show_cust_adr_special === '1'"
            [ttInvalid]="invalid.cust_adr_special?.invalid ?? false"
            [ttInvalidText]="invalid.cust_adr_special?.message ?? ''"
            ttLabel="cust_adr_special"
            [(ttModel)]="get.cust_adr_special"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-input
            *ngIf="get.setting_customeredit_show_cust_adr_street === '1'"
            [ttInvalid]="invalid.cust_adr_street?.invalid ?? false"
            [ttInvalidText]="invalid.cust_adr_street?.message ?? ''"
            ttLabel="cust_adr_street"
            [(ttModel)]="get.cust_adr_street"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-search
            *ngIf="get.cust_adr_special === '0' && get.setting_customeredit_show_postplace_search_street === '1'"
            [ttInvalid]="invalid.postplace_search_street?.invalid ?? false"
            [ttInvalidText]="invalid.postplace_search_street?.message ?? ''"
            ttLabel="postplace_search_street"
            [(ttModel)]="get.postplace_search_street"
            [ttSearch]="postplaceSearch"
            (ttOnSelected)="onPostplaceSelected($event)"
            (ttOnClear)="onPostplaceSelected()"
        >
            <ng-container buttons>
                <tt-form-field-button ttId="add" ttIcon="fas fa-plus" (ttClick)="openPostplaceDialog()" ttTooltip="add_postplace" [ttTranslateTooltip]="true"></tt-form-field-button>
            </ng-container>
        </tt-search>
        <tt-input
            *ngIf="get.setting_customeredit_show_cust_adr_mail === '1'"
            [ttInvalid]="invalid.cust_adr_mail?.invalid ?? false"
            [ttInvalidText]="invalid.cust_adr_mail?.message ?? ''"
            ttLabel="cust_adr_mail"
            [(ttModel)]="get.cust_adr_mail"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-search
            *ngIf="get.cust_adr_special === '0' && get.setting_customeredit_show_postplace_search_mail === '1'"
            [ttInvalid]="invalid.postplace_search_mail?.invalid ?? false"
            [ttInvalidText]="invalid.postplace_search_mail?.message ?? ''"
            ttLabel="postplace_search_mail"
            [(ttModel)]="get.postplace_search_mail"
            [ttSearch]="postplaceMailSearch"
            (ttOnSelected)="onPostplaceMailSelected($event)"
            (ttOnClear)="onPostplaceMailSelected()"
        >
            <ng-container buttons>
                <tt-form-field-button ttId="add" ttIcon="fas fa-plus" (ttClick)="openPostplaceMailDialog()" ttTooltip="add_postplace" [ttTranslateTooltip]="true"></tt-form-field-button>
            </ng-container>
        </tt-search>
        <ng-container *ngIf="get.cust_adr_special === '1'">
            <tt-input
                *ngIf="get.setting_customeredit_show_cust_adr_3 === '1'"
                [ttInvalid]="invalid.cust_adr_3?.invalid ?? false"
                [ttInvalidText]="invalid.cust_adr_3?.message ?? ''"
                ttLabel="cust_adr_3"
                [(ttModel)]="get.cust_adr_3"
                (ttModelChange)="onCommonChange()"
            ></tt-input>
            <tt-input
                *ngIf="get.setting_customeredit_show_cust_adr_postplacepostplace_id === '1'"
                [ttInvalid]="invalid.cust_adr_postplace?.invalid ?? false"
                [ttInvalidText]="invalid.cust_adr_postplace?.message ?? ''"
                ttLabel="cust_adr_postplace"
                [(ttModel)]="get.cust_adr_postplace"
                (ttModelChange)="onCommonChange()"
            ></tt-input>
            <tt-input
                *ngIf="get.setting_customeredit_show_cust_adr_postplacepostplace_id === '1'"
                [ttInvalid]="invalid.postplace_id?.invalid ?? false"
                [ttInvalidText]="invalid.postplace_id?.message ?? ''"
                ttLabel="zipcode"
                [(ttModel)]="get.postplace_id"
                (ttModelChange)="onCommonChange()"
            ></tt-input>
        </ng-container>
        <tt-select
            *ngIf="get.setting_customeredit_show_country_id === '1'"
            [ttInvalid]="invalid.country_id?.invalid ?? false"
            [ttInvalidText]="invalid.country_id?.message ?? ''"
            ttLabel="country_id"
            [(ttModel)]="get.country_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="countries"
            ttDataId="country_id"
            ttDataName="country_name"
        ></tt-select>
        <tt-input-phone
            *ngIf="get.setting_customeredit_show_cust_telephone === '1'"
            [ttInvalid]="invalid.cust_telephone?.invalid ?? false"
            [ttInvalidText]="invalid.cust_telephone?.message ?? ''"
            ttLabel="cust_telephone"
            [(ttModel)]="get.cust_telephone"
            (ttModelChange)="onCommonChange()"
        ></tt-input-phone>
        <tt-input-email
            *ngIf="get.setting_customeredit_show_cust_email === '1'"
            [ttInvalid]="invalid.cust_email?.invalid ?? false"
            [ttInvalidText]="invalid.cust_email?.message ?? ''"
            ttLabel="cust_email"
            [(ttModel)]="get.cust_email"
            (ttModelChange)="onCommonChange()"
        ></tt-input-email>
        <tt-input
            *ngIf="get.setting_customeredit_show_cust_fax === '1'"
            [ttInvalid]="invalid.cust_fax?.invalid ?? false"
            [ttInvalidText]="invalid.cust_fax?.message ?? ''"
            ttLabel="cust_fax"
            [(ttModel)]="get.cust_fax"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-input
            *ngIf="get.setting_customeredit_show_cust_www === '1'"
            [ttInvalid]="invalid.cust_www?.invalid ?? false"
            [ttInvalidText]="invalid.cust_www?.message ?? ''"
            ttLabel="cust_www"
            ttInputMode="url"
            [(ttModel)]="get.cust_www"
            (ttModelChange)="onCommonChange()"
        >
            <ng-container buttons>
                <tt-form-field-button ttId="goto" ttIcon="fas fa-window-restore" (ttClick)="openUrlInNewWindow()"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <ng-container *ngIf="get.is_customer === '1'">
            <tt-input
                *ngIf="get.setting_customeredit_show_delivery_cust_no === '1'"
                [ttInvalid]="invalid.delivery_cust_no?.invalid ?? false"
                [ttInvalidText]="invalid.delivery_cust_no?.message ?? ''"
                ttLabel="delivery_cust_no"
                [ttModel]="get.delivery_cust_no"
                ttReadonly
            ></tt-input>
            <tt-search
                *ngIf="get.setting_customeredit_show_delivery_cust_name === '1'"
                [ttInvalid]="invalid.delivery_cust_name?.invalid ?? false"
                [ttInvalidText]="invalid.delivery_cust_name?.message ?? ''"
                ttLabel="delivery_cust_name"
                [(ttModel)]="get.delivery_cust_name"
                [ttSearch]="deliveryCustomerSearch"
                (ttOnSelected)="onDeliveryCustomerSelected($event)"
                (ttOnClear)="onDeliveryCustomerSelected()"
            ></tt-search>
            <tt-input
                *ngIf="get.setting_customeredit_show_invoice_cust_no === '1'"
                [ttInvalid]="invalid.invoice_cust_no?.invalid ?? false"
                [ttInvalidText]="invalid.invoice_cust_no?.message ?? ''"
                ttLabel="invoice_cust_no"
                [ttModel]="get.invoice_cust_no"
                ttReadonly
            ></tt-input>
            <tt-search
                *ngIf="get.setting_customeredit_show_invoice_cust_name === '1'"
                [ttInvalid]="invalid.invoice_cust_name?.invalid ?? false"
                [ttInvalidText]="invalid.invoice_cust_name?.message ?? ''"
                ttLabel="invoice_cust_name"
                [(ttModel)]="get.invoice_cust_name"
                [ttSearch]="invoiceCustomerSearch"
                (ttOnSelected)="onInvoiceCustomerSelected($event)"
                (ttOnClear)="onInvoiceCustomerSelected()"
            ></tt-search>
        </ng-container>

        <tt-datetime *ngIf="get.reg_datetime > '' && get.setting_customeredit_show_reg_datetime === '1'" ttLabel="reg_datetime" [ttModel]="get.reg_datetime" ttReadonly></tt-datetime>
        <tt-datetime *ngIf="get.mod_datetime > '' && get.setting_customeredit_show_mod_datetime === '1'" ttLabel="mod_datetime" [ttModel]="get.mod_datetime" ttReadonly></tt-datetime>
    </ng-container>
</ng-template>

<ng-template #other>
    <ng-container *ngIf="!!get && !!params">
        <tt-select
            *ngIf="get.setting_customeredit_show_businessco_no === '1'"
            [ttInvalid]="invalid.businessco_no?.invalid ?? false"
            [ttInvalidText]="invalid.businessco_no?.message ?? ''"
            ttLabel="businessco"
            [(ttModel)]="get.businessco_no"
            (ttModelChange)="onBusinessCoChanged($event)"
            [ttData]="companies"
            ttDataId="businessco_no"
            ttDataName="company_name"
        ></tt-select>
        <tt-input
            *ngIf="get.setting_customeredit_show_org_no === '1'"
            [ttInvalid]="invalid.org_no?.invalid ?? false"
            [ttInvalidText]="invalid.org_no?.message ?? ''"
            ttLabel="org_no"
            [(ttModel)]="get.org_no"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-search
            *ngIf="params.cust_no > '0' && get.setting_customeredit_show_brreg_find_customer === '1'"
            ttLabel="customeredit_brreg_find_customer"
            [(ttModel)]="get.brreg_find_customer"
            [ttSearch]="brRegSearch"
            ttDataId="organisasjonsnummer"
            ttDataName="resultnavn"
            (ttOnSelected)="onBrRegSelected($event)"
        ></tt-search>
        <tt-checkbox
            *ngIf="get.show_activecustomer === '1'"
            [ttInvalid]="invalid.activecustomer?.invalid ?? false"
            [ttInvalidText]="invalid.activecustomer?.message ?? ''"
            ttLabel="activecustomer"
            [(ttModel)]="get.activecustomer"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-checkbox
            *ngIf="get.setting_show_is_customer === '1'"
            [ttInvalid]="invalid.is_customer?.invalid ?? false"
            [ttInvalidText]="invalid.is_customer?.message ?? ''"
            ttLabel="is_customer"
            [(ttModel)]="get.is_customer"
            (ttModelChange)="onIsCustomerChanged()"
        ></tt-checkbox>
        <tt-input
            *ngIf="get.setting_customeredit_show_acc_cust_no === '1'"
            [hidden]="get.is_customer === '0'"
            [ttInvalid]="invalid.acc_cust_no?.invalid ?? false"
            [ttInvalidText]="invalid.acc_cust_no?.message ?? ''"
            ttLabel="acc_cust_no"
            [(ttModel)]="get.acc_cust_no"
            (ttModelChange)="onCommonChange()"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="customerbuscos" [ttGotoParms]="{ cust_no: get.cust_no }"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-checkbox
            *ngIf="get.setting_show_is_supplyer === '1'"
            [ttInvalid]="invalid.is_supplyer?.invalid ?? false"
            [ttInvalidText]="invalid.is_supplyer?.message ?? ''"
            ttLabel="is_supplyer"
            [(ttModel)]="get.is_supplyer"
            (ttModelChange)="onIsSupplierChanged()"
        ></tt-checkbox>
        <div [hidden]="get.is_supplyer === '0'">
            <tt-input
                *ngIf="get.setting_customeredit_show_acc_supp_no === '1'"
                [ttInvalid]="invalid.acc_supp_no?.invalid ?? false"
                [ttInvalidText]="invalid.acc_supp_no?.message ?? ''"
                ttLabel="acc_supp_no"
                [(ttModel)]="get.acc_supp_no"
                (ttModelChange)="onCommonChange()"
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="customerbuscos" [ttGotoParms]="{ cust_no: get.cust_no }"></tt-form-field-button>
                </ng-container>
            </tt-input>
            <tt-checkbox
                *ngIf="get.show_supplier_stop_purchase === '1'"
                [ttInvalid]="invalid.supplier_stop_purchase?.invalid ?? false"
                [ttInvalidText]="invalid.supplier_stop_purchase?.message ?? ''"
                ttLabel="supplier_stop_purchase"
                [(ttModel)]="get.supplier_stop_purchase"
                (ttModelChange)="onCommonChange()"
            ></tt-checkbox>
            <tt-select
                *ngIf="get.setting_customeredit_show_portal_user_keyno_purchaser === '1'"
                [ttInvalid]="invalid.portal_user_keyno_purchaser?.invalid ?? false"
                [ttInvalidText]="invalid.portal_user_keyno_purchaser?.message ?? ''"
                ttLabel="portal_user_keyno_purchaser"
                [(ttModel)]="get.portal_user_keyno_purchaser"
                (ttModelChange)="onCommonChange()"
                [ttData]="portalUsers"
            ></tt-select>
            <tt-input-number
                *ngIf="get.setting_customeredit_show_deliverytime_from_supplier === '1'"
                [ttInvalid]="invalid.deliverytime_from_supplier?.invalid ?? false"
                [ttInvalidText]="invalid.deliverytime_from_supplier?.message ?? ''"
                ttLabel="deliverytime_from_supplier"
                [(ttModel)]="get.deliverytime_from_supplier"
                (ttModelChange)="onCommonChange()"
                ttFormatNumber
            ></tt-input-number>
            <tt-input-number
                *ngIf="get.setting_customeredit_show_supplier_handling_days === '1'"
                [ttInvalid]="invalid.supplier_handling_days?.invalid ?? false"
                [ttInvalidText]="invalid.supplier_handling_days?.message ?? ''"
                ttLabel="supplier_handling_days"
                [(ttModel)]="get.supplier_handling_days"
                (ttModelChange)="onCommonChange()"
                ttFormatNumber
            ></tt-input-number>
        </div>
        <tt-select
            *ngIf="get.setting_customeredit_show_language_id === '1'"
            [ttInvalid]="invalid.language_id?.invalid ?? false"
            [ttInvalidText]="invalid.language_id?.message ?? ''"
            ttLabel="business_language_id"
            [(ttModel)]="get.language_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="languages"
        ></tt-select>
        <tt-input
            *ngIf="get.setting_customeredit_show_cust_name_sort === '1'"
            [ttInvalid]="invalid.cust_name_sort?.invalid ?? false"
            [ttInvalidText]="invalid.cust_name_sort?.message ?? ''"
            ttLabel="cust_name_sort"
            [(ttModel)]="get.cust_name_sort"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-checkbox
            *ngIf="get.show_pickstop === '1'"
            [ttInvalid]="invalid.pickstop?.invalid ?? false"
            [ttInvalidText]="invalid.pickstop?.message ?? ''"
            ttLabel="pickstop"
            [(ttModel)]="get.pickstop"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-checkbox
            *ngIf="get.setting_customeredit_show_creditstop === '1'"
            [ttInvalid]="invalid.creditstop?.invalid ?? false"
            [ttInvalidText]="invalid.creditstop?.message ?? ''"
            ttLabel="creditstop"
            [(ttModel)]="get.creditstop"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-input-number
            *ngIf="get.setting_customeredit_show_creditstop_amount === '1'"
            [ttInvalid]="invalid.creditstop_amount?.invalid ?? false"
            [ttInvalidText]="invalid.creditstop_amount?.message ?? ''"
            ttLabel="creditstop_amount"
            [(ttModel)]="get.creditstop_amount"
            (ttModelChange)="onCommonChange()"
            ttTextAlign="right"
            ttDecimals="2"
            ttFormatNumber
        ></tt-input-number>
        <tt-input *ngIf="get.default_cust_no > '0' && get.setting_customeredit_show_default_cust_name === '1'" ttLabel="default_cust_name" [ttModel]="get.default_cust_name" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="customeredit" [ttGotoParms]="{ cust_no: get.default_cust_no }"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-checkbox
            *ngIf="get.setting_customeredit_show_is_private === '1'"
            [ttInvalid]="invalid.is_private?.invalid ?? false"
            [ttInvalidText]="invalid.is_private?.message ?? ''"
            ttLabel="is_private"
            [(ttModel)]="get.is_private"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-checkbox
            *ngIf="get.setting_customeredit_show_common_01 === '1'"
            [ttInvalid]="invalid.common_01?.invalid ?? false"
            [ttInvalidText]="invalid.common_01?.message ?? ''"
            ttLabel="tt_customeredit_common_01"
            [(ttModel)]="get.common_01"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-textarea
            *ngIf="get.setting_customeredit_show_cust_note === '1'"
            [ttInvalid]="invalid.cust_note?.invalid ?? false"
            [ttInvalidText]="invalid.cust_note?.message ?? ''"
            ttLabel="cust_note"
            [(ttModel)]="get.cust_note"
            (ttModelChange)="onCommonChange()"
        ></tt-textarea>
        <tt-input-number
            *ngIf="get.setting_customeredit_show_bankaccount === '1'"
            [ttInvalid]="invalid.bankaccount?.invalid ?? false"
            [ttInvalidText]="invalid.bankaccount?.message ?? ''"
            ttLabel="bankaccount"
            [(ttModel)]="get.bankaccount"
            (ttModelChange)="onCommonChange()"
        ></tt-input-number>
        <tt-input *ngIf="get.setting_customeredit_show_bic === '1'" [ttInvalid]="invalid.bic?.invalid ?? false" [ttInvalidText]="invalid.bic?.message ?? ''" ttLabel="bic" [(ttModel)]="get.bic" (ttModelChange)="onCommonChange()"></tt-input>
        <tt-input *ngIf="get.setting_customeredit_show_iban === '1'" [ttInvalid]="invalid.iban?.invalid ?? false" [ttInvalidText]="invalid.iban?.message ?? ''" ttLabel="iban" [(ttModel)]="get.iban" (ttModelChange)="onCommonChange()"></tt-input>
        <tt-input
            *ngIf="get.setting_customeredit_show_bankCode === '1'"
            [ttInvalid]="invalid.bankCode?.invalid ?? false"
            [ttInvalidText]="invalid.bankCode?.message ?? ''"
            ttLabel="bankCode"
            [(ttModel)]="get.bankCode"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-select
            *ngIf="get.setting_customeredit_show_ehf_groupingmethod_no === '1'"
            [ttInvalid]="invalid.ehf_groupingmethod_no?.invalid ?? false"
            [ttInvalidText]="invalid.ehf_groupingmethod_no?.message ?? ''"
            ttLabel="ehf_groupingmethod"
            [(ttModel)]="get.ehf_groupingmethod_no"
            (ttModelChange)="onCommonChange()"
            [ttData]="groupingMethods"
            ttDataId="ehf_groupingmethod_no"
            ttDataName="ehf_groupingmethod_name"
        ></tt-select>
        <tt-search
            *ngIf="get.show_account_no_purchase === '1'"
            [ttInvalid]="invalid.account_no_purchase?.invalid ?? false"
            [ttInvalidText]="invalid.account_no_purchase?.message ?? ''"
            ttLabel="account_no_purchase"
            [(ttModel)]="get.account_name_purchase"
            (ttModelChange)="onCommonChange()"
            [ttSearch]="searchAccounts"
            (ttOnSelected)="onAccountPurchaseSelected($event)"
            (ttOnClear)="onAccountPurchaseSelected()"
            ttMinLength="1"
        ></tt-search>
        <tt-input
            *ngIf="get.show_gln_number === '1'"
            [ttInvalid]="invalid.gln_number?.invalid ?? false"
            [ttInvalidText]="invalid.gln_number?.message ?? ''"
            ttLabel="gln_number"
            [(ttModel)]="get.gln_number"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-input
            *ngIf="get.show_region === '1'"
            [ttInvalid]="invalid.region?.invalid ?? false"
            [ttInvalidText]="invalid.region?.message ?? ''"
            ttLabel="region"
            [(ttModel)]="get.region"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <ng-container *ngIf="get.show_autoinvoice === '1'">
            <tt-select
                *ngIf="get.setting_customeredit_show_autoinvoicemethod_keyno === '1'"
                [ttInvalid]="invalid.autoinvoicemethod_keyno?.invalid ?? false"
                [ttInvalidText]="invalid.autoinvoicemethod_keyno?.message ?? ''"
                ttLabel="autoinvoicemethod"
                [(ttModel)]="get.autoinvoicemethod_keyno"
                (ttModelChange)="onCommonChange()"
                [ttData]="autoInvoiceMethods"
                ttDataId="autoinvoicemethod_keyno"
                ttDataName="autoinvoicemethod_name"
            ></tt-select>
            <tt-date
                *ngIf="get.setting_customeredit_show_autoinvoicemethod_stopdate === '1'"
                [ttInvalid]="invalid.autoinvoicemethod_stopdate?.invalid ?? false"
                [ttInvalidText]="invalid.autoinvoicemethod_stopdate?.message ?? ''"
                [hidden]="!['30', '40'].includes(get.autoinvoicemethod_keyno)"
                ttLabel="tt_autoinvoicemethod_stopdate"
                [(ttModel)]="get.autoinvoicemethod_stopdate"
                (ttModelChange)="onCommonChange()"
            ></tt-date>
        </ng-container>
        <tt-select
            *ngIf="get.setting_customeredit_show_default_stockplace_id === '1'"
            [ttInvalid]="invalid.default_stockplace_id?.invalid ?? false"
            [ttInvalidText]="invalid.default_stockplace_id?.message ?? ''"
            ttLabel="default_stockplace_id"
            [(ttModel)]="get.default_stockplace_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="stockplaces"
            ttDataId="stockplace_id"
            ttDataName="stockplace_name"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_user_in_charge === '1'"
            [ttInvalid]="invalid.user_in_charge?.invalid ?? false"
            [ttInvalidText]="invalid.user_in_charge?.message ?? ''"
            ttLabel="user_in_charge"
            [(ttModel)]="get.user_in_charge"
            (ttModelChange)="onCommonChange()"
            [ttData]="users"
            ttDataId="user_id"
            ttDataName="user_name"
        ></tt-select>
        <tt-input
            *ngIf="get.setting_show_winner_supplier_id === '1' && get.is_supplyer === '1'"
            [ttInvalid]="invalid.winner_supplier_id?.invalid ?? false"
            [ttInvalidText]="invalid.winner_supplier_id?.message ?? ''"
            ttLabel="winner_supplier_id"
            [(ttModel)]="get.winner_supplier_id"
            (ttModelChange)="onCommonChange()"
        ></tt-input>
        <tt-input *ngIf="get.show_webcode === '1'" ttLabel="webcode" [(ttModel)]="get.webcode"></tt-input>
    </ng-container>
</ng-template>

<ng-template #terms>
    <ng-container *ngIf="!!get && !!params">
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_delm_no === '1'"
            [ttInvalid]="invalid.cust_delm_no?.invalid ?? false"
            [ttInvalidText]="invalid.cust_delm_no?.message ?? ''"
            ttLabel="cust_delm_no"
            [(ttModel)]="get.cust_delm_no"
            (ttModelChange)="onCommonChange()"
            [ttData]="deliveryMethods"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_delt_no === '1'"
            [ttInvalid]="invalid.cust_delt_no?.invalid ?? false"
            [ttInvalidText]="invalid.cust_delt_no?.message ?? ''"
            ttLabel="cust_delt_no"
            [(ttModel)]="get.cust_delt_no"
            (ttModelChange)="onCommonChange()"
            [ttData]="deliveryTerms"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_custgrp_id === '1'"
            [ttInvalid]="invalid.custgrp_id?.invalid ?? false"
            [ttInvalidText]="invalid.custgrp_id?.message ?? ''"
            ttLabel="custgrp"
            [(ttModel)]="get.custgrp_id"
            (ttModelChange)="onCustomerGroupChanged($event)"
            [ttData]="customerGroups"
            ttDataId="custgrp_id"
            ttDataName="custgrp_name"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-bars" ttGoto="custgrps"></tt-form-field-button>
                <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="custgrpmenu" [ttGotoParms]="{ custgrp_id: get.custgrp_id }"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-select
            *ngIf="get.show_custgrp2_keyno === '1' && get.setting_customeredit_show_custgrp2_keyno === '1'"
            [ttInvalid]="invalid.custgrp2_keyno?.invalid ?? false"
            [ttInvalidText]="invalid.custgrp2_keyno?.message ?? ''"
            ttLabel="custgrp2_keyno"
            [(ttModel)]="get.custgrp2_keyno"
            (ttModelChange)="onCommonChange()"
            [ttData]="customerGroups2"
            ttDataId="custgrp_keyno"
            ttDataName="custgrp_name"
        ></tt-select>
        <tt-select
            *ngIf="get.show_discgrpcust === '1' && get.setting_customeredit_show_discgrpcust_keyno === '1'"
            [ttInvalid]="invalid.discgrpcust_keyno?.invalid ?? false"
            [ttInvalidText]="invalid.discgrpcust_keyno?.message ?? ''"
            ttLabel="discgrpcust"
            [(ttModel)]="get.discgrpcust_keyno"
            (ttModelChange)="onCommonChange()"
            [ttData]="customerDiscountGroups"
            ttDataId="discgrpcust_keyno"
            ttDataName="discgrpcust_name"
            ttShowClearButton
        ></tt-select>

        <tt-checkbox
            *ngIf="get.setting_customeredit_show_spesial_discgrp === '1'"
            [ttInvalid]="invalid.spesial_discgrp?.invalid ?? false"
            [ttInvalidText]="invalid.spesial_discgrp?.message ?? ''"
            ttLabel="spesial_discgrp"
            [(ttModel)]="get.spesial_discgrp"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-select
            *ngIf="get.setting_customeredit_show_seller_no === '1'"
            [ttInvalid]="invalid.seller_no?.invalid ?? false"
            [ttInvalidText]="invalid.seller_no?.message ?? ''"
            ttLabel="seller"
            [(ttModel)]="get.seller_no"
            (ttModelChange)="onCommonChange()"
            [ttData]="sellers"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-bars" ttGoto="sellers"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_business_id === '1'"
            [ttInvalid]="invalid.cust_business_id?.invalid ?? false"
            [ttInvalidText]="invalid.cust_business_id?.message ?? ''"
            ttLabel="business"
            [(ttModel)]="get.cust_business_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="businesses"
            ttDataId="business_id"
            ttDataName="business_name"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-bars" ttGoto="businesss"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_coop_id === '1'"
            [ttInvalid]="invalid.cust_coop_id?.invalid ?? false"
            [ttInvalidText]="invalid.cust_coop_id?.message ?? ''"
            ttLabel="coop"
            [(ttModel)]="get.cust_coop_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="coops"
            ttDataId="coop_id"
            ttDataName="coop_name"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_order_valuta_id === '1'"
            [ttInvalid]="invalid.cust_order_valuta_id?.invalid ?? false"
            [ttInvalidText]="invalid.cust_order_valuta_id?.message ?? ''"
            ttLabel="cust_order_valuta_id"
            [(ttModel)]="get.cust_order_valuta_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="valutas"
            ttDataId="valuta_id"
            ttDataName="valuta_name"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_invoice_valuta_id === '1'"
            [ttInvalid]="invalid.cust_invoice_valuta_id?.invalid ?? false"
            [ttInvalidText]="invalid.cust_invoice_valuta_id?.message ?? ''"
            ttLabel="cust_invoice_valuta_id"
            [(ttModel)]="get.cust_invoice_valuta_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="valutas"
            ttDataId="valuta_id"
            ttDataName="valuta_name"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_pricelist_id === '1'"
            [ttInvalid]="invalid.pricelist_id?.invalid ?? false"
            [ttInvalidText]="invalid.pricelist_id?.message ?? ''"
            ttLabel="pricelist"
            [(ttModel)]="get.pricelist_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="pricelist"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_pricelist_id2 === '1'"
            [ttInvalid]="invalid.pricelist_id2?.invalid ?? false"
            [ttInvalidText]="invalid.pricelist_id2?.message ?? ''"
            ttLabel="pricelist2"
            [(ttModel)]="get.pricelist_id2"
            (ttModelChange)="onCommonChange()"
            [ttData]="pricelist"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_purchase_pricelist_id === '1'"
            [ttInvalid]="invalid.purchase_pricelist_id?.invalid ?? false"
            [ttInvalidText]="invalid.purchase_pricelist_id?.message ?? ''"
            ttLabel="purchase_pricelist_id"
            [(ttModel)]="get.purchase_pricelist_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="pricelist"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_purchase_pricelist_id2 === '1'"
            [ttInvalid]="invalid.purchase_pricelist_id2?.invalid ?? false"
            [ttInvalidText]="invalid.purchase_pricelist_id2?.message ?? ''"
            ttLabel="purchase_pricelist_id2"
            [(ttModel)]="get.purchase_pricelist_id2"
            (ttModelChange)="onCommonChange()"
            [ttData]="pricelist"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_paym_id === '1'"
            [ttInvalid]="invalid.cust_paym_id?.invalid ?? false"
            [ttInvalidText]="invalid.cust_paym_id?.message ?? ''"
            ttLabel="cust_paym"
            [(ttModel)]="get.cust_paym_id"
            (ttModelChange)="onCommonChange()"
            [ttData]="paymentTypes"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_tax_keyno === '1'"
            [ttInvalid]="invalid.tax_keyno?.invalid ?? false"
            [ttInvalidText]="invalid.tax_keyno?.message ?? ''"
            ttLabel="tax"
            [(ttModel)]="get.tax_keyno"
            (ttModelChange)="onCommonChange()"
            [ttData]="taxes"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_invoicemethod_no === '1'"
            [ttInvalid]="invalid.invoicemethod_no?.invalid ?? false"
            [ttInvalidText]="invalid.invoicemethod_no?.message ?? ''"
            ttLabel="invoicemethod"
            [(ttModel)]="get.invoicemethod_no"
            (ttModelChange)="onCommonChange()"
            [ttData]="invoiceMethods"
            ttDataId="invoicemethod_no"
            ttDataName="invoicemethod_name"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_invoiceinterval_keyno === '1'"
            [ttInvalid]="invalid.invoiceinterval_keyno?.invalid ?? false"
            [ttInvalidText]="invalid.invoiceinterval_keyno?.message ?? ''"
            ttLabel="invoiceinterval"
            [(ttModel)]="get.invoiceinterval_keyno"
            (ttModelChange)="onCommonChange()"
            [ttData]="invoiceIntervals"
            ttDataId="invoiceinterval_keyno"
            ttDataName="invoiceinterval_name"
        ></tt-select>
        <tt-select
            *ngIf="get.setting_customeredit_show_cust_factoring_no === '1'"
            [ttInvalid]="invalid.cust_factoring_no?.invalid ?? false"
            [ttInvalidText]="invalid.cust_factoring_no?.message ?? ''"
            ttLabel="factoring"
            [(ttModel)]="get.cust_factoring_no"
            (ttModelChange)="onCommonChange()"
            [ttData]="factorings"
        ></tt-select>
        <tt-checkbox
            *ngIf="get.setting_customeredit_show_partial_invoicing === '1'"
            [ttInvalid]="invalid.partial_invoicing?.invalid ?? false"
            [ttInvalidText]="invalid.partial_invoicing?.message ?? ''"
            ttLabel="partial_invoicing"
            [(ttModel)]="get.partial_invoicing"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-checkbox
            *ngIf="get.setting_customeredit_show_freight_paid_by === '1'"
            [ttInvalid]="invalid.freight_paid_by?.invalid ?? false"
            [ttInvalidText]="invalid.freight_paid_by?.message ?? ''"
            ttLabel="freight_paid_by"
            [(ttModel)]="get.freight_paid_by"
            (ttModelChange)="onCommonChange()"
        ></tt-checkbox>
        <tt-checkbox *ngIf="get.setting_customeredit_show_carriers_paid_by_customer === '1'" ttLabel="carriers_paid_by_customer" [(ttModel)]="get.carriers_paid_by_customer" (ttModelChange)="onCommonChange()"></tt-checkbox>
        <tt-input *ngIf="get.show_contract_id_on_customer === '1'" ttLabel="contract_id" [(ttModel)]="get.contract_id" (ttModelChange)="onCommonChange()"></tt-input>
        <tt-select
            *ngIf="get.setting_customeredit_show_custbonusdeal_keyno === '1'"
            ttLabel="custbonusdeal"
            [(ttModel)]="get.custbonusdeal_keyno"
            (ttModelChange)="onCommonChange()"
            [ttData]="customerBonusDeals"
            ttDataId="custbonusdeal_keyno"
            ttDataName="custbonusdeal_name"
        ></tt-select>
    </ng-container>
</ng-template>
